/**
 * Restricted absence-code (e.g. NBP-14 "Absence Hours") gating.
 * Ported from script_plugin.user.js's ABSENCE_JIRA_IDS / ABSENCE_ALLOWED_USERS.
 *
 * To allow more people: add their exact TimeBox display name to
 * ABSENCE_ALLOWED_USERS. To restrict more codes: add them to ABSENCE_JIRA_IDS.
 */

export const ABSENCE_JIRA_IDS = ["NBP-14"];

export const ABSENCE_ALLOWED_USERS = [
    "Vignesh Mathivanan",   // OSM - USA
    "Christian Pfisterer",  // OSM - Germany
    "Michael Dingler"       // OSM - Germany
];

export const ABSENCE_BLOCKED_MESSAGE =
    "NBP-14 (Absence Hours) may only be booked by authorized OutSource Managers (Germany/USA). Please remove or change this code.";

export const ABSENCE_UNKNOWN_USER_NOTE =
    "Your TimeBox user could not be identified, so absence-code (NBP-14) permissions cannot be verified. Please contact the author of this tool.";

export function isAbsenceJiraId(jiraId: string): boolean {
    return ABSENCE_JIRA_IDS.includes(String(jiraId || "").trim().toUpperCase());
}

/** Fail-closed: an unidentified user (empty name) is never treated as allowed. */
export function isAbsenceAllowedUser(currentUserName: string): boolean {
    const name = String(currentUserName || "").trim().toLowerCase();
    if (!name) { return false; }
    return ABSENCE_ALLOWED_USERS.some((n) => n.trim().toLowerCase() === name);
}

export function isAbsenceCodeBlocked(jiraId: string, currentUserName: string): boolean {
    return isAbsenceJiraId(jiraId) && !isAbsenceAllowedUser(currentUserName);
}

export function absenceBlockMessage(currentUserName: string): string {
    return currentUserName
        ? ABSENCE_BLOCKED_MESSAGE
        : `${ABSENCE_BLOCKED_MESSAGE}\n\n${ABSENCE_UNKNOWN_USER_NOTE}`;
}
